import { render, staticRenderFns } from "./trainChangeInfos.vue?vue&type=template&id=34a31d09&scoped=true&"
import script from "./trainChangeInfos.vue?vue&type=script&lang=ts&"
export * from "./trainChangeInfos.vue?vue&type=script&lang=ts&"
import style0 from "./trainChangeInfos.vue?vue&type=style&index=0&id=34a31d09&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a31d09",
  null
  
)

export default component.exports